.root {
  .item {
    padding: 0;
    align-self: center;
    display: flex;
  }

  .divider {
    content: '';
    position: relative;
    border-left: solid 1px var(--theme--color--grey--main);
  }
}